export default __webpack_public_path__ + "static/media/gothenburg_grid_s.c67b5289.jpg";